import React, { useState } from 'react';
import './ProductSection.css';
import Filters from './Filters';
import ProductList from './ProductList';

function ProductSection({ productList, filterList, brandList }) {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);

  const toggleCategoryFilter = (categoryId) => {
    setSelectedCategories((prevCategories) =>
      prevCategories.includes(categoryId)
        ? prevCategories.filter((id) => id !== categoryId)
        : [...prevCategories, categoryId]
    );
  };

  const toggleBrandFilter = (brandId) => {
    setSelectedBrands((prevBrands) =>
      prevBrands.includes(brandId)
        ? prevBrands.filter((id) => id !== brandId)
        : [...prevBrands, brandId]
    );
  };

  const resetFilters = () => {
    setSelectedCategories([]);
    setSelectedBrands([]);
  };

  const filteredProducts = productList.filter((product) => {
    const matchesCategory =
      selectedCategories.length === 0 || selectedCategories.includes(product.category);
    const matchesBrand =
      selectedBrands.length === 0 || selectedBrands.includes(product.brand);
    return matchesCategory && matchesBrand;
  });

  return (
    <div className="product-section-container">
      {filterList.length > 0 && (
        <>
          <h2>Categorías</h2>
          <Filters
            filterList={filterList}
            selectedFilters={selectedCategories}
            toggleFilter={toggleCategoryFilter}
            type="filter"
          />
        </>
      )}
      {brandList.length > 0 && (
        <>
          <h2>Marcas</h2>
          <Filters
            filterList={brandList}
            selectedFilters={selectedBrands}
            toggleFilter={toggleBrandFilter}
            type="brand"
          />
        </>
      )}
      {/* {filterList.length + brandList.length > 0 && (
        <button className="common-button generic-button" onClick={resetFilters}>
          Quitar Filtros
        </button>
      )} */}
      {productList.length === 0 ? (
        <p>No hay productos disponibles</p>
      ) : (
        <div className="products-products-list">
          <ProductList productList={filteredProducts} />
        </div>
      )}
    </div>
  );
};

export default ProductSection;
